import PropTypes from 'prop-types';

const TitleCell = ({ value }) => {
    return (
        <span
            title={value}
            className="block truncate font-GMedium text-sm -tracking-wider text-icoGray-500 dark:text-icoDarkMode-wolf">
            {value}
        </span>
    );
};

TitleCell.propTypes = {
    value: PropTypes.string
};

export default TitleCell;
